import {ValueObject} from '@s-ui/domain'

/**
 * @export
 * @class DisplayAdvertisingValueObject
 * @extends {ValueObject}
 */
export default class DisplayAdvertisingValueObject extends ValueObject {
  /**
   * @constructor
   * @param {String} url
   * @param {String} positions
   */
  constructor({url, positions}) {
    super({url, positions})
  }
}
